import { FieldStatusEnum, getFieldStatus } from 'components/form'
import { useEffect, useState } from 'react'
import { isEmpty } from 'util/validation/Util'

interface UseFieldStatusParams {
  initialValue: string
  currentValue: string
  dirty: boolean
  controlModifiedStatus?: boolean
  isValueEmpty?(value: string): boolean
}

export function useFieldStatus(params: UseFieldStatusParams): { status: FieldStatusEnum; showChangeStatus: boolean } {
  const { initialValue, currentValue, dirty, controlModifiedStatus = false, isValueEmpty = isEmpty } = params

  const [status, setStatus] = useState<FieldStatusEnum>(FieldStatusEnum.NAO_MODIFICADO)

  useEffect(() => {
    if (!controlModifiedStatus) return

    setStatus(getFieldStatus(initialValue, currentValue, isValueEmpty, dirty))
  }, [initialValue, dirty, currentValue, controlModifiedStatus, isValueEmpty])

  return {
    status,
    showChangeStatus: status !== FieldStatusEnum.NAO_MODIFICADO,
  }
}
